import {ApiBase} from "@/src/model/ApiBase";
import {LOGIN_API_TYPE} from "@/src/model/apiTypes";

export const LoginType = Object.freeze({
    BASIC_AUTHENTICATION: 'basic_authentication',
    FABRIC: 'fabric'
});

export class LoginApi extends ApiBase {
    async [LOGIN_API_TYPE.BASIC_LOGIN]({username, password}) {
        return await this.httpPost('login/', {
            username,
            password
        })
    }

    async [LOGIN_API_TYPE.SAML_LOGIN]({uid, id_token}) {
        return await this.httpPost('saml/login/', {
            uid,
            id_token
        })
    }

    async [LOGIN_API_TYPE.LOGOUT]() {
        return await this.httpGet('logout/')
    }

    async [LOGIN_API_TYPE.GET_USER]() {
        return await this.httpGet('user/')
    }

    async [LOGIN_API_TYPE.USERS]() {
        return await this.httpGet('users/')
    }

    async [LOGIN_API_TYPE.GROUPS]() {
        return await this.httpGet('groups/')
    }

    async [LOGIN_API_TYPE.ADD_GROUP]({name}) {
        return await this.httpPost('groups/', {
            name
        })
    }

    async [LOGIN_API_TYPE.EDIT_GROUP]({id, data}) {
        return await this.httpPatch(`groups/${id}/`, data)
    }

    async [LOGIN_API_TYPE.DELETE_GROUP]({id}) {
        return await this.httpDelete(`groups/${id}/`)
    }

    async [LOGIN_API_TYPE.EDIT_USER]({id, data}) {
        return await this.httpPatch(`users/${id}/`, data)
    }

    async [LOGIN_API_TYPE.TRANSFER_OWNERSHIP]({id, transfer_to}) {
        return await this.httpPatch(`users/${id}/transfer/`, {transfer_to})
    }

    async [LOGIN_API_TYPE.DELETE_USER]({id}) {
        return await this.httpDelete(`users/${id}/`)
    }

    async [LOGIN_API_TYPE.INVITE_USER](data) {
        return await this.httpPost('users/invite/', data)
    }

    async [LOGIN_API_TYPE.GET_GLOBAL_PERMISSIONS]() {
        return await this.httpGet('permissions/')
    }

    async [LOGIN_API_TYPE.RESET_PASSWORD]({id}) {
        return await this.httpPatch(`users/${id}/reset_password/`)
    }

    async [LOGIN_API_TYPE.EMAIL_RESET]({email}) {
        return await this.httpPost('user/reset_password/', {email})
    }

    async [LOGIN_API_TYPE.ROLES]() {
        return await this.httpGet('roles/')
    }

    async [LOGIN_API_TYPE.UPDATE_ROLE_USERS]({roleId, users}) {
        return await this.httpPatch(`roles/${roleId}/users/`, {users})
    }

    async [LOGIN_API_TYPE.GET_AUDIT_LOGS]({from, count}) {
        return await this.httpGet(`audit_logs/?count=${count}&from=${from}`)
    }

    async [LOGIN_API_TYPE.AUDIT_LOGS_COUNT]() {
        return await this.httpGet('audit_logs/count/')
    }

    async [LOGIN_API_TYPE.GET_USER_PREFERENCES]() {
        return await this.httpGet('user/preferences/')
    }
    async [LOGIN_API_TYPE.UPDATE_USER_PREFERENCE]({preference, value}) {
        return await this.httpPatch('user/preferences/', {
            preference,
            value
        })
    }
}

